import React from 'react';
import logo from './logo.svg';
import './App.css';
import axios from 'axios';

function App() {
  const btnClick=()=>{
    axios.get('https://my-typescript-worker.1414939223.workers.dev')
    .then(function (response) {
      // handle success
      console.log(response);
    })
  }
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <button onClick={btnClick}>
          点击事件
        </button>
      </header>
    </div>
  );
}

export default App;
